// Deprecated: shim that redirects to AuthContext
// Kept for backward-compat imports of useDemo/PROFILI from existing pages.
import { useAuth } from "@/context/AuthContext";

export const PROFILI = [];
export const DemoProvider = ({ children }) => children;
export const useDemo = () => useAuth();
